import { clearFilterParams } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React from 'react'

import { minicrudsClient } from '../../utils/apollo/api'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query Minicruds($search: String, $filter: MinicrudFilter) {
    minicruds(limit: 900000, search: $search, filter: $filter) {
      id
    }
  }
`

const SelectAllMinicrudsLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={minicrudsClient}
      {...props}
    />
  )
}

export default SelectAllMinicrudsLink
